import * as React from 'react'
import { Provider } from 'react-redux'
import { createRoot } from 'react-dom/client'

import * as serviceWorkerRegistration from './serviceWorkerRegistration'

import store from './redux/store'
import { setFeaturesList, setUpdatePrompt } from './redux/actions'

import { FeaturesListEnum } from './utils/constants/enum/featuresList'
import { getIsIonic } from './utils/functions'

import './utils/deployment'
import { getIsPayingStudentAccessingCourseMaterial } from './utils/jpbouvetmethod'

const startRhythmBot = async () => {
	const container = document.getElementById('root')
	const root = createRoot(container)

	let Routes
	const testWebRedirectLocal = false
	const isPayingStudentAccessingCourseMaterial = await getIsPayingStudentAccessingCourseMaterial()
	if (
		!testWebRedirectLocal &&
		getIsIonic() &&
		// If we have determined that this is a paying student of jpbouvetmethod.com
		// accessing course material then we should load the legacy web app.
		!isPayingStudentAccessingCourseMaterial
	) {
		Routes = (await import('./routes/Ionic/index.js')).Routes
	} else {
		Routes = (await import('./routes/Web.js')).Routes
	}

	root.render(
		<Provider store={store}>
			<Routes />
		</Provider>
	)

	serviceWorkerRegistration.register({
		onUpdate: (registration) => {
			if (registration && registration.waiting) {
				registration.waiting.postMessage({ type: 'SKIP_WAITING' })
			}

			store.dispatch(setUpdatePrompt(true))

			store.dispatch(setFeaturesList(FeaturesListEnum.UPDATE))
			localStorage.setItem('featuresList', FeaturesListEnum.UPDATE)
		},
	})
}

startRhythmBot()
